/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Outcome_LabelInputs */

const en_directory_submit_outcome_label = /** @type {(inputs: Directory_Submit_Outcome_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing outcome`)
};

const zh_directory_submit_outcome_label = /** @type {(inputs: Directory_Submit_Outcome_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交结果`)
};

/**
* | output |
* | --- |
* | "Listing outcome" |
*
* @param {Directory_Submit_Outcome_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_outcome_label = /** @type {((inputs?: Directory_Submit_Outcome_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Outcome_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_outcome_label(inputs)
	return zh_directory_submit_outcome_label(inputs)
});
export { directory_submit_outcome_label as "directory.submit.outcome_label" }